/**
 * @owner @Appboy/ingestion
 */

import type { AllRouteEndpoints } from "../routeTypes";

export const appsAppGroupIdQuickAddUserProfileCacheKeys: AllRouteEndpoints[] = [];
